import { render } from "./ParentEdit.vue?vue&type=template&id=d12fb8b2&scoped=true&ts=true"
import script from "./ParentEdit.vue?vue&type=script&lang=ts"
export * from "./ParentEdit.vue?vue&type=script&lang=ts"

import "./ParentEdit.vue?vue&type=style&index=0&id=d12fb8b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d12fb8b2"]])

export default __exports__